import React from "react"
import { StylesProvider } from "@mui/styles"

export function GlobalCssPriority ({ children = null }) {
  return <StylesProvider injectFirst>{children}</StylesProvider>
}

export default GlobalCssPriority
